import { SafeA } from "../../components/Safe/SafeStyled";

export const FirstLoginResourcesDE: FirstLoginResourcesInterface = {
  title: "Erste Anmeldung",
  nextButton: "Weiter",
  backButton: "Zurück",
  signatureTitle: "Unterschrift",
  errorMissingInput: "Bitte füllen Sie alle Felder aus",
  phoneNumber: {
    label: "Telefonnummer",
    placeholder: "Bitte Telefonnummer eingeben",
  },
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
  },
  profilePicture: {
    label: "Profilbild",
    name: "profilePicture",
    error: "Bitte wählen Sie Ihr Profilbild aus",
    validation: "Falsches Profilbild",
    description: () => (
      <>
        <h4>Dateien hier ablegen oder zum Hochladen klicken.</h4>
        <span className="text-muted font-13">Nur Bilder, max 6MB</span>
      </>
    ),
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  errorPasswordMatch: "Passwörter stimmen nicht überein.",
  password: {
    label: "Passwort",
    placeholder: "Bitte geben Sie das Passwort ein",
  },
  passwordRepeat: {
    label: "Passwort wiederholen",
    placeholder: "Bitte wiederholen Sie das Passwort",
  },
  termsAgreementInput: {
    name: "termsConditions",
    error: "Bitte akzeptieren Sie die Nutzungsbedingungen",
    label:
      "Ich akzeptiere die Nutzungsbedingungen, Datenschutzrichtlinie und bin mit anderen in der Anwendung verfügbaren Regeln vertraut.",
  },
  termsAgreement: (uslovipath, politika, ostalapravila) => (
    <>
      <SafeA
        href={`${process.env.PUBLIC_URL}/pdf/` + uslovipath}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="mdi me-2"></i>
        Nutzungsbedingungen
      </SafeA>
      <SafeA
        href={`${process.env.PUBLIC_URL}/pdf/` + politika}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="mdi me-2"></i>
        Datenschutzrichtlinie
      </SafeA>
      <SafeA
        href={`${process.env.PUBLIC_URL}/pdf/` + ostalapravila}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="mdi me-2"></i>
        Andere Regeln
      </SafeA>
    </>
  ),
};

interface IErrors {
  registerPic: string;
}

export interface FirstLoginResourcesInterface {
  title: string;
  nextButton: string;
  backButton: string;
  signatureTitle: string;
  errorMissingInput: string;
  phoneNumber: {
    label: string;
    placeholder: string;
  };
  profilePicture: {
    label: string;
    name: string;
    error: string;
    validation: string;
    description: () => JSX.Element;
  };
  errorPasswordMatch: string;
  password: {
    label: string;
    placeholder: string;
  };
  passwordRepeat: {
    label: string;
    placeholder: string;
  };
  successModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  termsAgreement: (
    uslovipath: string,
    politika: string,
    ostalapravila: string
  ) => JSX.Element;
  termsAgreementInput: {
    label: string;
    name: string;
    error: string;
  };
  errors: IErrors;
}
